import type { RegionalUserData as GraftRegionalUser } from '@graft/nuget-gc.webportals.regionalusers'

import type { RegionalUser } from '../types/user.type'

export async function regionalUserToObject(entity: GraftRegionalUser): Promise<RegionalUser> {
  const [id, email, firstname, lastname, avatarUrl] = await Promise.all([
    entity.get_userId(),
    entity.get_userEmail(),
    entity.get_firstname(),
    entity.get_lastname(),
    entity.get_avatarUrl(),
  ])

  return {
    id,
    email,
    firstname,
    lastname,
    avatarUrl: avatarUrl?.length > 0 ? avatarUrl : null,
  }
}
